import Logout from "../components/account/Logout";
import Tasks from "../components/tasks/Tasks";
import Profile from "../components/account/Profile";
import StudentResults from "../components/student-ui/StudentResults";
import StudentWelcome from "../components/student-ui/StudentWelcome";


export enum NavPlacement {
    MAIN,
    PROFILE,
    NONE,
}

class StudentPages {
    pages: StudentPage[] = []
    constructor() {
        this.pages = [
            new StudentPage("Tulokset", "/student/results", <StudentResults />, [NavPlacement.MAIN]),
            new StudentPage("Tehtävät", "/student/tasks", <Tasks />, [NavPlacement.MAIN]),
            new StudentPage("Profiili", "/student/profile", <Profile />, [NavPlacement.PROFILE]),
            new StudentPage("Kirjaudu ulos", "/student/logout", <Logout />, [NavPlacement.PROFILE]),
            new StudentPage("Tervetuloa", "/student/", <StudentWelcome />, [NavPlacement.MAIN]),
        ]
    }

    getByPlacement(placement: NavPlacement) {
        return this.pages.filter(page => {
            return page.navPlacements.includes(placement)
        });
    }
}

class StudentPage {
    name: string = "";
    path: string = "";
    content: JSX.Element = <></>;
    navPlacements: NavPlacement[] = []

    constructor(name: string, path: string, content: JSX.Element, navPlacements: NavPlacement[] = []) {
        this.name = name;
        this.path = path;
        this.content = content;
        this.navPlacements = navPlacements;
    }
}


export default StudentPages;